const state = {
  users: [],
  profiles: [],
  surveys: [],
  totalUsers: null,
  totalProfiles: null,
  totalSurveys: null,
};

const getters = {
  loadedUsers: (state) => {
    if (state.totalUsers === null) return false;

    return state.totalUsers === state.users.length;
  },
  loadedProfiles: (state) => {
    if (state.totalProfiles === null) return false;

    return state.totalProfiles === state.profiles.length;
  },
  loadedSurveys: (state) => {
    if (state.totalSurveys === null) return false;

    return state.totalSurveys === state.surveys.length;
  },
};

const mutations = {
  RESET_DEFAULT(state) {
    if (state.users.length === 1) {
      state.users = [];
      state.profiles = [];
      state.surveys = [];
    }
  },
  ADD_USER(state, payload) {
    state.users.push(payload);
  },
  ADD_PROFILE(state, payload) {
    state.profiles.push(payload);
  },
  ADD_SURVEY(state, payload) {
    state.surveys.push(payload);
  },
  SET_USERS(state, payload) {
    state.users.push(...payload);
  },
  SET_PROFILES(state, payload) {
    state.profiles.push(...payload);
  },
  SET_SURVEYS(state, payload) {
    state.surveys.push(...payload);
  },
  SET_TOTAL_USERS(state, payload) {
    state.totalUsers = +payload;
  },
  SET_TOTAL_PROFILES(state, payload) {
    state.totalProfiles = +payload;
  },
  SET_TOTAL_SURVEYS(state, payload) {
    state.totalSurveys = +payload;
  },
};

export default {
  namespaced: true,
  getters,
  state,
  mutations,
};
